<ng-container *ngIf="!reportService.isSendingEmailNotification() else sendingEmailNotification">
  <mat-accordion>
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="navigate-back list-box d-flex justify-content-between">
            <div
              class="back-arrow"
              *ngIf="
              !(
                userService.userrole() === Userrole.Mitarbeiter &&
                knowledgeBaseService.activeModule() === 'reportDowntime'
              )
            "
            >
              <i
                class="bi bi-arrow-left-short cursor-pointer display-6"
                (click)="back()"
                app-stop-propagation
              ></i>
            </div>
            <div class="list-box"></div>
          </div>
          <mat-chip-listbox class="ms-2">
            <!-- current selection PL / WP / PS / M -->
            <mat-chip>
              {{ knowledgeBaseService.expandedNodesPath() }}
            </mat-chip>
          </mat-chip-listbox>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <!-- This is the tree node template for leaf nodes -->
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
          <ng-container *ngIf="node.type !== 'button'">
            <button
              mat-icon-button
              disabled
              *ngIf="node.type !== 'button'"
            ></button>
            {{ node.name }}
          </ng-container>
          <!-- use a disabled button to provide padding for tree leaf -->
        </mat-tree-node>
        <!-- This is the tree node template for expandable nodes -->
        <mat-tree-node
          class="cursor-pointer"
          *matTreeNodeDef="let node; when: hasChild"
          matTreeNodePadding
          matTreeNodeToggle
          (click)="
          this.treeControl.isExpanded(node)
            ? loadChildren(node)
            : collapseNode(node)
        "
        >
          <button
            mat-icon-button
            matTreeNodeToggle
            [attr.aria-label]="'Toggle ' + node.name"
            (click)="
            this.treeControl.isExpanded(node)
              ? loadChildren(node)
              : collapseNode(node)
          "
          >
            <mat-icon class="mat-icon-rtl-mirror">
              {{ treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}
            </mat-icon>
          </button>
          <div class="d-flex justify-content-between align-items-center w-100">
            {{ node.name }}

            <button
              mat-icon-button
              [matMenuTriggerFor]="menu"
              aria-label="Example icon-button with a menu"
              *ngIf="!(userService.userrole() === Userrole.Mitarbeiter)"
              class="menu-button"
              (click)="openMenu($event)"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
          </div>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="editNode(node)">
              <i class="bi bi-pencil me-2"></i>
              <span>bearbeiten</span>
            </button>
            <button mat-menu-item (click)="deleteNode(node)">
              <i class="bi bi-trash me-2"></i>
              <span>löschen</span>
            </button>
            @if (node.level !== NodeLevel.CATEGORY) {
              <button mat-menu-item (click)="moveNode(node)">
                <i class="bi bi-shuffle me-2"></i>
                <span>Zuweisung ändern</span>
              </button>
            }
            @if (node.level === NodeLevel.SOLUTION) {
              <button mat-menu-item (click)="getLinkedReports(node.id)">
                <i class="bi bi-diagram-3 me-2"></i>
                <span>verknüpfte Stillstände</span>
              </button>
            }
          </mat-menu>
        </mat-tree-node>

        <!-- Add button node template -->
        <mat-tree-node
          *matTreeNodeDef="let node; when: isAddButton"
          matTreeNodePadding
          class="button-node"

        >
          <div class="d-flex justify-content-between align-items-center">
            <button class="add-button" mat-stroked-button (click)="addNode(node.level)">
              <mat-icon>add</mat-icon>
              {{ getActionForNodeLevel(node.level) }} hinzufügen
            </button>
            <button *ngIf="node.level === 2 && knowledgeBaseService.activeModule() === 'reportDowntime'"
                    class="btn btn-qundis-escalate ms-3"
                    (click)="createNewEscalation()"
            >
              Keine Lösung möglich
            </button>
          </div>
        </mat-tree-node>
      </mat-tree>
    </mat-expansion-panel>
  </mat-accordion>
</ng-container>

<ng-template #sendingEmailNotification>
  <div class="qundis-inner-content">
    <div class="d-flex justify-content-center align-items-center">
      <mat-spinner diameter="30"></mat-spinner>
      <span class="ms-2">Stillstandsmeldung wird weitergeleitet...</span>
    </div>
  </div>
</ng-template>
